import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/useraccount/details/loadscreenview", vo, successCallback, failureCallback);
    },
    saveUserAccount: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/useraccount/details/activeuseraccount", vo, successCallback, failureCallback);
    },
    savePassword: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/useraccount/details/savepassword", vo, successCallback, failureCallback);
    }
};

export default EditService;